import classNames from 'classnames';
import React, { FC, useRef } from 'react';
import { useVideoPlay } from '../../../utils/hooks/useVideoPlay';
import styles from './VideoPreview.scss';
import { IOuter } from './VideoPreview.types';

export const VideoPreview: FC<IOuter> = ({
  thumbnailUrl,
  videoPreviewUrl,
  isPlaying,
}) => {
  const videoElementRef = useRef<HTMLVideoElement>(null);
  useVideoPlay({ videoElementRef, isPlaying });

  return (
    <div
      className={classNames(styles.holder, {
        [styles.isPlaying]: isPlaying,
      })}
    >
      <div
        className={styles.thumbnail}
        style={{ backgroundImage: `url('${thumbnailUrl}')` }}
      />

      {videoPreviewUrl && (
        <div className={styles.playerHolder}>
          <video
            className={styles.player}
            ref={videoElementRef}
            src={videoPreviewUrl}
            muted
            loop
            preload="metadata"
          />
        </div>
      )}
    </div>
  );
};
